<template>
  <div v-loading="loading" class="chart">
    <div class="message-block" ref="intersectionContainer">
      <div class="message" :key="mes.id" v-for="mes in messages">
        <div class="date">
          {{ new Date(mes.createdDate).toLocaleDateString("ru-RU") }}
          {{
            new Date(mes.createdDate).toLocaleTimeString("ru-RU", {
              hour: "2-digit",
              minute: "2-digit"
            })
          }}
        </div>

        <div class="text">
          {{ mes.content }}
        </div>
      </div>

      <div ref="observerTrigger">&nbsp;</div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["messageGroupId"],
  data() {
    return {
      loading: false,
      page: 1,
      messages: [],
      observer: null
    };
  },

  methods: {
    async loadMessages() {
      this.loading = true;
      try {
        this.messages = await this.$store.dispatch("fetchMessages", {
          messageGroupId: this.messageGroupId,
          page: this.page
        });
        if (this.messages.length === 20) {
          this.createObserver();
        }
      } catch (e) {
        this.$ErrorsMod(e);
      } finally {
        this.loading = false;
      }
    },
    async loadMoreMessages() {
      try {
        this.page++;
        const result = await this.$store.dispatch("fetchMessages", {
          messageGroupId: this.messageGroupId,
          page: this.page
        });
        this.messages = [...this.messages, ...result];
        if (result.length % 20 !== 0 && result.length > 0 && this.observer) {
          this.unobserveIntersecting();
        }
      } catch (e) {
        this.$ErrorsMod(e);
      }
    },

    clearState() {
      this.page = 1;
      this.messages = [];
      if (this.observer) {
        this.unobserveIntersecting();
        this.observer = null;
      }
    },
    createObserver() {
      const callback = e => {
        if (e[0].isIntersecting) {
          const beforeH = this.$refs.intersectionContainer.scrollTop;
          this.loadMoreMessages();
          this.$refs.intersectionContainer.scrollTop = beforeH;
        }
      };
      const options = {
        root: this.$refs.intersectionContainer,
        rootMargin: "0px",
        threshold: 0
      };
      this.observer = new IntersectionObserver(callback, options);
      this.observer.observe(this.$refs.observerTrigger);
    },
    unobserveIntersecting() {
      if (this.$refs.observerTrigger) {
        this.observer.unobserve(this.$refs.observerTrigger);
      }
    }
  },

  watch: {
    messageGroupId() {
      this.clearState();
      this.loadMessages();
    }
  }
};
</script>
<style scoped>
.chart {
  box-sizing: border-box;
  height: calc(100vh - 390px);
  display: flex;
  flex-direction: column;
  gap: 1em;
  margin-top: 1em;
}
.message-block {
  flex-grow: 1;
  overflow: hidden auto;
  display: flex;
  flex-direction: column;
  gap: 1em;
}
.message {
  background: #40a0ff25;
  padding: 1em;
  border-radius: 4px;
  align-self: flex-start;
}
.date {
  font-size: 12px;
  text-align: end;
  margin-bottom: 1em;
  color: #909399;
}
.text {
  font-size: 14px;
}
.reading {
  color: #409eff;
}
.sending-area {
  flex-shrink: 0;
  display: flex;
  gap: 1em;
}
.send-btn {
  align-self: end;
  font-size: 1.5em;
  padding: 0.2em 0.5em;
}
</style>
